"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const useMergeRefs_1 = __importDefault(require("../../hooks/useMergeRefs"));
const BoxConstants_1 = require("./BoxConstants");
const Box_module_scss_1 = __importDefault(require("./Box.module.scss"));
const Box = (0, react_1.forwardRef)(({ className, id, elementType = "div", children, disabled, border, borderColor, rounded, shadow, margin, marginX, marginY, marginTop, marginEnd, marginBottom, marginStart, padding, paddingX, paddingY, paddingTop, paddingEnd, paddingBottom, paddingStart, textColor, backgroundColor }, ref) => {
    const componentRef = (0, react_1.useRef)(null);
    const mergedRef = (0, useMergeRefs_1.default)({ refs: [ref, componentRef] });
    return react_1.default.createElement(elementType, {
        ref: mergedRef,
        className: (0, classnames_1.default)(Box_module_scss_1.default.box, className, { [BoxConstants_1.DISABLED.DISABLED]: disabled }, border, borderColor, rounded, shadow, margin, marginX, marginY, marginTop, marginEnd, marginBottom, marginStart, padding, paddingX, paddingY, paddingTop, paddingEnd, paddingBottom, paddingStart, textColor, backgroundColor),
        id: id
    }, children);
});
Object.assign(Box, {
    borders: BoxConstants_1.BORDER,
    borderColors: BoxConstants_1.BORDER_COLOR,
    roundeds: BoxConstants_1.ROUNDED,
    shadows: BoxConstants_1.SHADOW,
    margins: BoxConstants_1.MARGIN,
    marginXs: BoxConstants_1.MARGIN_X,
    marginYs: BoxConstants_1.MARGIN_Y,
    marginTops: BoxConstants_1.MARGIN_TOP,
    marginEnds: BoxConstants_1.MARGIN_END,
    marginBottoms: BoxConstants_1.MARGIN_BOTTOM,
    marginStarts: BoxConstants_1.MARGIN_START,
    paddings: BoxConstants_1.PADDING,
    paddingXs: BoxConstants_1.PADDING_X,
    paddingYs: BoxConstants_1.PADDING_Y,
    paddingTops: BoxConstants_1.PADDING_TOP,
    paddingEnds: BoxConstants_1.PADDING_END,
    paddingBottoms: BoxConstants_1.PADDING_BOTTOM,
    paddingStarts: BoxConstants_1.PADDING_START,
    backgroundColors: BoxConstants_1.BACKGROUND_COLORS,
    textColors: BoxConstants_1.COLORS
});
exports.default = Box;
